var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oct-account-dialog',{staticClass:"ss-signup-complete",attrs:{"title":"送信完了しました","text":"パスワード設定のご案内をメールいたしました。メールに記載されているURLよりパスワードの設定登録をお願いいたします。","caption":"メールが届かない場合、管理者にお問い合わせください。"}})
}
var staticRenderFns = []

export { render, staticRenderFns }